export default __webpack_public_path__ + "static/media/recurring-billing-img02.6fc33b6d.png";